"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const CheckboxDefault = props => {
  const {
    height,
    width
  } = props;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: "MuiSvgIcon-root",
    focusable: "false",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    width: width,
    height: height
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "18",
    height: "18",
    x: "3",
    y: "3",
    fill: "#FFF",
    stroke: "#FFF",
    strokeWidth: "0",
    rx: "4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
  }));
};

CheckboxDefault.defaultProps = {
  height: 24,
  width: 24
};
var _default = CheckboxDefault;
exports.default = _default;